if (!customElements.get('collection-back-to-top')) {
  customElements.define(
    'collection-back-to-top',
    class CollectionBackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.SCROLL_BOUNDARY = 500;
        this.moved = false;

        document.addEventListener('scroll', this.checkVisibility.bind(this));
        this.button.addEventListener('click', this.handleButtonClick.bind(this));
      }
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }
      handleButtonClick(e) {
        e.preventDefault();

        let rootElement = document.documentElement;

        rootElement.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      checkVisibility(e) {
        if (window.scrollY > this.SCROLL_BOUNDARY) {
          this.button.classList.remove('back-to-top-hidden');
        } else {
          this.button.classList.add('back-to-top-hidden');
        }
      }
    }
  );
}
